import { TableCell } from "@mui/material"

export const TableHeaderCell = ({ children, sx }) => (
  <TableCell sx={{...sx, fontSize: 18, fontWeight: "bold"}}>
      {children}
  </TableCell>
)